module.exports = __webpack_public_path__ + "img/qiu.6356f668.png";